var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FsEntryType } from '@lucidlink/sdk';
import { isNotNil } from '@lucidlink/tscore';
import { Box, FileIcon, FolderIcon, Typography, } from '@lucidlink/uicore';
import { getTruncatedPath } from './getTruncatedPath';
import styles from './Path.module.css';
const PathBars = () => (_jsxs(Box, { gap: "s", orientation: "vertical", children: [_jsx("div", { className: styles.Bar }), _jsx("div", { className: styles.SubBar })] }));
_react_refresh_temp_1 = PathBars;
$RefreshReg$(_react_refresh_temp_1, "PathBars");
const PathIconMap = {
    dir: FolderIcon,
    file: FileIcon,
    link: FolderIcon,
};
const PathIcon = ({ iconProps, rootType = FsEntryType.DIR, }) => {
    const Icon = PathIconMap[rootType];
    const { color = 'default', size = 'xsmall' } = iconProps ?? {};
    return _jsx(Icon, { color: color, size: size });
};
_react_refresh_temp_2 = PathIcon;
$RefreshReg$(_react_refresh_temp_2, "PathIcon");
const PATH_TYPOGRAPHY_KIND = 'p-small';
export const Path = ({ className, filespaceName, iconProps, isLoading = false, path, rootType, shouldTruncate = false, }) => {
    _react_refresh_temp_4();
    const displayedPath = useMemo(() => (shouldTruncate ? getTruncatedPath(path) : path), [shouldTruncate, path]);
    const pathComponents = useMemo(() => displayedPath
        ?.split('/')
        .flatMap((v) => ['/', v])
        .slice(1), [displayedPath]);
    if (isLoading) {
        return _jsx(PathBars, {});
    }
    if (!isNotNil(path)) {
        return null;
    }
    const [rootName, ...restOfPath] = pathComponents || [];
    return (_jsxs(Box, { align: "center", className: className, gap: "2xs", wrap: true, children: [_jsxs(Box, { align: "center", gap: "xs", children: [_jsx(PathIcon, { iconProps: iconProps, rootType: rootType }), filespaceName && (_jsxs(_Fragment, { children: [_jsx(Typography, { "data-testid": "path-filespace-name", kind: PATH_TYPOGRAPHY_KIND, children: filespaceName }), _jsx(Typography, { kind: PATH_TYPOGRAPHY_KIND, children: "/" })] })), _jsx(Typography, { kind: PATH_TYPOGRAPHY_KIND, children: rootName })] }), restOfPath.map((segment, i) => (_jsx(Typography, { kind: PATH_TYPOGRAPHY_KIND, children: segment }, `${segment}$${i}`)))] }));
};
_react_refresh_temp_3 = Path;
$RefreshReg$(_react_refresh_temp_3, "Path");
_react_refresh_temp_4(Path, "0f+wXiXuhhDYpl21Cza0PBzVTX0=");
